import { SxProps, Theme } from '@mui/material';

export const styles: Record<'container' | 'skeleton', SxProps<Theme>> = {
  container: {
    '& + &': {
      borderTop: (theme) => `1px solid ${theme.palette.gray[200]}`,
    },
    '&:hover': {
      background: (theme) => theme.palette.gray[200],
      cursor: 'pointer',
    },
    alignItems: 'center',
    background: (theme) => theme.palette.gray[50],
    borderRadius: '8px',
    display: 'flex',
    flexDirection: 'row',
    gap: (theme) => theme.spacing(2),
    height: '100%',
    padding: (theme) => theme.spacing(2),
    width: '100%',
  },
  skeleton: {
    borderRadius: '8px',
    display: 'flex',
  },
};
